export const T = {
  en_GB: {
    riskAssessmentResult: "Risk Assessment Result",
    initialScore: "Initial",
    adjustmentLabel: "Adjustment",
    finalScore: "Final",
    scoreCapped: "The risk score was capped by the risk model's cap rule.",
  },
  nb_NO: {
    riskAssessmentResult: "Resultat av risikovurdering",
    initialScore: "Utgangspunkt",
    adjustmentLabel: "Justering",
    finalScore: "Endelig",
    scoreCapped: "Risikoscoren ble begrenset av risikomodellens takregel.",
  },
} as const;
